import React from "react";
import { withRouter } from "react-router-dom";

import { ADVANCED_CARE_PROGRAM } from "@/core/constants";

import { getQueryParams } from "../../utils/filters";
import { Policy } from "../../components/Policy/Policy";

const AdvancedCarePolicyPage = (props) => {
  const version = getQueryParams("version", props.location.search);

  return <Policy policyType={ADVANCED_CARE_PROGRAM} version={version} />;
};

export default withRouter(AdvancedCarePolicyPage);
